module.exports = __webpack_public_path__ + "img/plus.04727ef8.svg";